/**
 * Defines all events that can be listened for on Client
 */
const AUTH_CHANGED = 'auth:changed';
const AUTH_LOGOUT = 'auth:logout';
const AUTH_EXPIRED = 'auth:expired';
const REQUEST_STARTED = 'request:started';
const REQUEST_SUCCEEDED = 'request:succeeded';
const REQUEST_FAILED = 'request:failed';
const REQUEST_RETRIED = 'request:retried';
module.exports = {
  AUTH_CHANGED,
  AUTH_EXPIRED,
  AUTH_LOGOUT,
  REQUEST_STARTED,
  REQUEST_SUCCEEDED,
  REQUEST_FAILED,
  REQUEST_RETRIED
};